<template>
    <div class="masclientes-section">
        <div class="masclientes-content">
            <h1 class="masclientes-title fuente-posm">
                Más clientes en horarios lentos y retención en horarios altos
            </h1>
            <p class="masclientes-text fuente-nova">
                Pierdes ingresos cuando tienes mesas vacías en horarios lentos, y pierdes clientes cuando están llenos porque se van por las filas largas.
                <br><br>
                Nuestra pantalla inteligente se adapta automáticamente a cada situación y aumenta tus ventas.
            </p>
        </div>
        <div class="masclientes-image">
            <img :src="a14" alt="Pantalla inteligente">
        </div>
    </div>
</template>

<script>
export default {
    name: 'MasClientesNew',
    data() {
        return {
            a14: require('@/assets/images/a14.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.masclientes-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.masclientes-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.masclientes-image img {
    width: 280px;
    height: auto;
}

.masclientes-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.masclientes-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.masclientes-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .masclientes-title {
        font-size: 60px;
    }

    .masclientes-text {
        font-size: 27px;
    }

    .masclientes-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .masclientes-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .masclientes-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .masclientes-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .masclientes-image img {
        width: 40%;
        max-width: 160px;
    }

    .masclientes-title {
        font-size: 24px;
        line-height: 1.2;
    }

    .masclientes-text {
        font-size: 16px;
        padding-left: 10px;
    }
}
</style>
